import { Routes, Route } from "react-router-dom";

import WarehouseListScreen from "screens/App/CRM/Warehouse/WarehouseListScreen";
import WarehouseInfoScreen from "screens/App/CRM/Warehouse/WarehouseInfoScreen";
import WarehouseDetailScreen from "screens/App/CRM/Warehouse/WarehouseDetailScreen";
import WarehouseEditScreen from "screens/App/CRM/Warehouse/WarehouseEditScreen";
import WarehouseCreateScreen from "screens/App/CRM/Warehouse/WarehouseCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const WarehouseRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<WarehouseListScreen />} />
      <Route path="create" element={<WarehouseCreateScreen />} />
      <Route path=":id/detail" element={<WarehouseDetailScreen />} />
      <Route path=":id/edit" element={<WarehouseEditScreen />} />
      <Route path="info" element={<WarehouseInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default WarehouseRouter;
